import React from 'react';

export interface TableToolbarProps {
  search?: React.ReactNode;
  filters?: React.ReactNode;
  actions?: React.ReactNode;
  summary?: React.ReactNode;
  className?: string;
}

const TableToolbar: React.FC<TableToolbarProps> = ({
  search,
  filters,
  actions,
  summary,
  className = '',
}) => {
  return (
    <div className={`rounded-xl border border-monday-border-light bg-white/80 p-4 shadow-xs backdrop-blur ${className}`}>
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div className="flex min-w-0 flex-1 flex-col gap-3 md:flex-row md:items-end">
          {search}
          {filters}
        </div>
        {(summary || actions) && (
          <div className="flex shrink-0 flex-wrap items-center gap-2 lg:justify-end">
            {summary}
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableToolbar;
